import { Routes, Route } from 'react-router-dom'
import { RootState } from '../store/store'
import { useSelector } from 'react-redux'
import { Navbar } from '../shared/components/navbar/navabr'
import { Footer } from '../shared/components/footer/footer'
import { useIsAuthenticated } from '../shared/hooks/useIsAuthenticated'
import { Logout } from '../pages/logout/Logout'
import { Login } from 'pages/auth/login/Login'
import { SignupForm } from 'pages/auth/signup/components/signup-form/SignupForm'
import { PersonalArea } from 'pages/personal-area/PersonalArea'
import { EAppRoutes } from 'types/enums/EAppRoutes'

export const AppRouter = () => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const isAuthenticated = useIsAuthenticated()

  const showNavbar = useSelector((state: RootState) => state.layout.showNavbar)
  const showFooter = useSelector((state: RootState) => state.layout.showFooter)

  return (
    <>
      {showNavbar && <Navbar />}
      <Routes>
        <Route index path={EAppRoutes.LOGIN} element={<Login />} />
        <Route index path={EAppRoutes.FANZA} element={<Login />} />
        <Route index path={EAppRoutes.SIGN_UP} element={<SignupForm />} />
        <Route
          index
          path={EAppRoutes.FANZA_SIGN_UP}
          element={<SignupForm baseUrl="fanza" />}
        />
        <Route path={EAppRoutes.LOGOUT} element={<Logout />} />
        <Route
          path={EAppRoutes.FANZA_LOGOUT}
          element={<Logout baseUrl="fanza" />}
        />
        <Route path={EAppRoutes.PERSONAL_AREA} element={<PersonalArea />} />
        <Route path="*" element={<p>There&apos;s nothing here: 404!</p>} />
      </Routes>
      {showFooter && <Footer />}
    </>
  )
}
